/*
 * Minimal CartPerformance shim.
 *
 * Dawn's cart.js references a global `CartPerformance` for performance
 * instrumentation, normally defined in performance.js. That file was missing
 * from this theme, so every cart update threw "ReferenceError: CartPerformance
 * is not defined" before the AJAX request could run — breaking quantity
 * changes and falling back to a full page reload.
 *
 * These methods are safe no-ops, except measure(), which must invoke its
 * callback because cart.js wraps the section re-render inside it.
 */
(function () {
  if (window.CartPerformance) return;

  window.CartPerformance = class CartPerformance {
    static createStartingMarker(benchmarkName) {
      try {
        return performance.mark(`${benchmarkName}:start`);
      } catch (e) {
        return null;
      }
    }

    static measureFromMarker(benchmarkName, startMarker) {
      /* no-op */
    }

    static measureFromEvent(benchmarkName, event) {
      /* no-op */
    }

    static measure(benchmarkName, callback) {
      if (typeof callback === 'function') callback();
    }
  };
}());
